<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">
                Dashboard
            </router-link>
            <router-link to="/school/attendance-management" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>Attendance Management
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Student Sign In/Sign Out Attendance
            </span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <card header-classes="bg-transparent">
                <modal :show.sync="modals.SignInModal" modal-classes="modal-dialog-centered modal-md">
                    <div class="card bg-secondary border-0 mb-0">
                        <div class="card-body">
                            <PageSpinner :onloader="onloader" />
                            <div class="form-horizontal">
                                <form role="form">
                                    <div class="card">
                                        <h5 class="card-header">Sign-In Daily Register</h5>
                                        <div class="card-body">
                                            <div class="text-center">
                                                <img v-if="StudentImageVal" :src="StudentImageVal" class="rounded"
                                                    alt="" height="50" />
                                                <img v-else src="/img/brand/loguser.png" class="rounded" alt=""
                                                    height="50" />
                                                <h5><small>{{ StudentNameVal }}</small> </h5>
                                            </div>
                                            <div class="form-group">
                                                <label>Custodian Name </label>
                                                <input v-model="CustodianVal" class="form-control"
                                                    placeholder="Custodian Name" />
                                            </div>
                                            <div>
                                                <div class="row align-items-center">
                                                    <div class="col-auto">
                                                        <img v-if="CustodianPictureVal" :src="CustodianPictureVal"
                                                            class="rounded custodian-thumb" alt="" />
                                                        <img v-else src="/img/brand/empty.png" class="rounded custodian-thumb" alt="" />
                                                    </div>
                                                    <div class="col">
                                                        <span>Custodian Passport here</span>
                                                        <ImageUploader @emitOutImgPathval="UpdateCustodianPictureVal" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <template slot="footer">
                        <base-button type="default" @click="modals.SignInModal = false">Cancel
                        </base-button>
                        <base-button type="success" @click.prevent="SubmitData()">Submit
                        </base-button>
                    </template>
                </modal>
                <div>
                    <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
                        <h3 class="mb-3 mb-md-0">
                            <i class="fa fa-clipboard-check"></i> Student Sign In / Sign Out
                        </h3>
                        <div class="col-md-5 p-0">
                            <base-input class="input-group-alternative mb-0" placeholder="Search by name, class or admission no..."
                                addon-left-icon="fa fa-search" v-model="searchval">
                            </base-input>
                        </div>
                    </div>
                    <list-skeleton v-if="!students" :rows="3" />
                    <div v-else>
                        <div v-if="!searchedResultQuery || searchedResultQuery.length === 0" class="text-center py-5">
                            <img src="/img/brand/empty.png" class="img-fluid mb-3" style="max-width:120px" />
                            <p class="text-muted">{{ students && students.length === 0 ? 'No Students Found.' : 'No students match your search.' }}</p>
                        </div>
                        <div v-else class="row">
                            <div class="col-lg-4 col-md-6" v-for="item in searchedResultQuery" :key="item.id">
                                <div class="card bg-success student-attendance-card m-2 animate__animated animate__backInUp">
                                    <div class="card-body-top" :class="item.hasSignOut ? 'bg-gradient-dark' : (item.hasSignIn ? 'bg-gradient-success' : 'bg-gradient-info')">
                                        <span class="status-badge badge" :class="item.hasSignOut ? 'badge-light' : (item.hasSignIn ? 'badge-warning' : 'badge-light')">
                                            <i class="fa" :class="item.hasSignOut ? 'fa-check-circle' : (item.hasSignIn ? 'fa-clock' : 'fa-hourglass-half')"></i>
                                            {{ item.hasSignOut ? 'Signed Out' : (item.hasSignIn ? 'At School' : 'Not Signed In') }}
                                        </span>
                                    </div>
                                    <div class="avatar-wrapper">
                                        <img v-if="item.passport" :src="item.passport" class="avatar-img" alt="" />
                                        <img v-else src="/img/brand/loguser.png" class="avatar-img" alt="" />
                                    </div>
                                    <div class="card-body text-center pt-5">
                                        <h5 class="mb-1 text-white">{{ item.studentName }}</h5>
                                        <p class="text-white small mb-3">
                                            {{ item.admNo }} &bull; {{ item.sch_Class }} {{ item.classOption }} {{ item.sectionName }}
                                        </p>
                                        <div v-if="item.hasSignOut == false">
                                            <button v-if="item.hasSignIn == false" class="btn btn-info btn-sm btn-block"
                                                v-on:click="OpenSignIn(item.studentId)">
                                                <i class="fa fa-sign-in-alt"></i> Sign In
                                            </button>
                                            <button v-if="item.hasSignIn == true" class="btn btn-success btn-sm btn-block"
                                                v-on:click="OpenSignOut(item.studentId)">
                                                <i class="fa fa-sign-out-alt"></i> Sign Out
                                            </button>
                                        </div>
                                        <div v-else class="text-muted small">
                                            <i class="fa fa-check-circle text-success"></i> Attendance complete
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </card>
        </div>
    </div>
</template>


<script>
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
import ImageUploader from "@/components/ImageUploader"
export default {
    name: "student",
    components: {
        PageSpinner, ImageUploader
    },
    mixins: [CheckStaffUser, Alert],
    data() {
        return {
            accessDetails: null,
            PortalDailyRegisterIdVal: 0,
            StudentIdVal: 0,
            StudentImageVal: null,
            StudentNameVal: "",
            CustodianVal: null,
            CustodianPictureVal: null,
            CommentVal: "",
            students: null,
            ImgPathval: "",
            uploadedimage: "",
            searchval: "",
            IsSignIn: true,
            onloader: "none",
            modals: {
                SignInModal: false
            }
        };
    },
    computed: {
        searchedResultQuery() {
            if (!this.students) return [];
            if (this.searchval) {
                return this.students.filter((item) => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            (v) =>
                                item.studentName.toLowerCase().includes(v) ||
                                item.sch_Class.toLowerCase().includes(v) ||
                                item.admNo.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.students;
            }
        },
    },
    methods: {
        UpdateCustodianPictureVal(data) {
            this.CustodianPictureVal = data;
        },
        SubmitData() {
            if (this.IsSignIn == true) {
                this.SubmitSignIn();
            } else {
                this.SubmitSignOut();
            }
        },
        OpenSignIn(Id) {
            this.onloader = "flex";
            this.$store
                .dispatch("PortalStudent/GetStudentById", Id)
                .then((resp) => {
                    this.StudentIdVal = Id;
                    if (resp.data.passport != null) {
                        this.StudentImageVal = resp.data.passport;
                    }
                    this.StudentNameVal = resp.data.lastName + ' ' + resp.data.firstName + ' ' + resp.data.middleName;
                    this.IsSignIn = true;
                    this.modals.SignInModal = true
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        OpenSignOut(Id) {
            this.onloader = "flex";
            this.$store
                .dispatch("PortalStudent/GetStudentById", Id)
                .then((resp) => {
                    this.StudentIdVal = Id;
                    if (resp.data.passport != null) {
                        this.StudentImageVal = resp.data.passport;
                    }
                    this.StudentNameVal = resp.data.lastName + ' ' + resp.data.firstName + ' ' + resp.data.middleName;
                    this.IsSignIn = false;
                    this.modals.SignInModal = true
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        SubmitSignIn() {
            let StudentId = this.StudentIdVal;
            let BroughtBy = this.CustodianVal;
            let BroughtByPicture = this.CustodianPictureVal;
            this.onloader = "flex";
            let userdata = {
                StudentId,
                BroughtBy,
                BroughtByPicture,
            }
            this.$store
                .dispatch("DailyRegister/SignInPortalDailyRegister", userdata)
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.CloseSignIn();
                        this.GetSchoolStudents();
                        this.onloader = "none";
                        this.ShowAlertSuccess('Submitted Successfully', '');
                    } else {
                        this.onloader = "none";
                        this.ShowAlertError(resp.responseMessage, '');
                    }

                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        SubmitSignOut() {
            let StudentId = this.StudentIdVal;
            let TakeHomeBy = this.CustodianVal;
            let TakeHomeByPicture = this.CustodianPictureVal;
            this.onloader = "flex";
            let userdata = {
                StudentId,
                TakeHomeBy,
                TakeHomeByPicture,
            }
            this.$store
                .dispatch("DailyRegister/SignOutPortalDailyRegister", userdata)
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.CloseSignOut();
                        this.GetSchoolStudents();
                        this.ShowAlertSuccess('Submitted Successfully', '');
                    } else {
                        this.ShowAlertError(resp.responseMessage, '');
                    }

                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetSchoolStudents() {
            this.onloader = "flex";
            this.$store
                .dispatch("PortalStudent/GetSchoolStudents")
                .then((resp) => {
                    this.students = resp.data;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },

        CloseSignIn() {
            this.modals.SignInModal = false
        },
        CloseSignOut() {
            this.modals.SignInModal = false
        },
    },
    mounted() {
        this.GetSchoolStudents();
    },
};
</script>

<style scoped>
.custodian-thumb {
    width: 90px;
    height: 90px;
    object-fit: cover;
}

.student-attendance-card {
    overflow: visible;
    border: none;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.student-attendance-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.15);
}

.card-body-top {
    height: 70px;
    border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    padding: 0.6rem;
}

.status-badge {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.02em;
}

.avatar-wrapper {
    margin-top: -45px;
    text-align: center;
}

.avatar-img {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 50%;
    border: 4px solid #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    background-color: #fff;
}
</style>

<style>
.inputfile+label {
    font-size: 1.25em;
    font-weight: 700;
    color: white;
    background-color: black;
    display: inline-block;
}

.inputfile:focus+label,
.inputfile+label:hover {
    background-color: red;
}
</style>
